import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Comments } from 'projects/Administration/src/app/business-entities/dwo-comments.model';
import { DwoDocumentsBusinessService } from 'projects/Administration/src/app/business-services/dwo-documents.service';
import { EditAppointmentService } from 'projects/Administration/src/app/business-services/edit-appointment.service';
@Component({
  selector: 'app-dwo-comments',
  templateUrl: './dwo-comments.component.html',
})
export class DwoCommentsComponent implements OnInit {
  response: Comments[];
  commentsLenght: number;

  constructor(
    private service: DwoDocumentsBusinessService,
    private readonly editAppointmentService: EditAppointmentService,
    private spinner: NgxSpinnerService,
  ) {}

  ngOnInit(): void {
    let id;

    //Check for historical WO tab -> If true then appointmentGuid will be of selected WO.
    if (
      this.editAppointmentService.isFromHistoricalWOTab ||
      this.editAppointmentService.isFromVehicleHistoricalTab
    ) {
      id = this.editAppointmentService.appointmentIdOfSelectedWO;
    } else {
      id = this.editAppointmentService.appointmentDetails.id;
    }

    this.getComments(id);
  }

  getComments(id) {
    this.spinner.show();
    this.service.getDwoComments(id).then((res) => {
      if (res.responseObject) {
        this.response = res.responseObject;
        if ( this.response?.length !== undefined) {
          this.response.forEach((x) => {
            if (x.updatedDate !== null)
              x.updatedDate = new Date(x.updatedDate + 'Z');
          });
          this.commentsLenght = this.response.length;
        } else {
          this.response = [];
        }
      }
    });
    this.spinner.hide();
  }
}
